import {useGa4MountEffect} from 'hooks/useGa4MountEffect'
import {VentrataDataProvider} from '../providers/VentrataDataProvider'
import {Footer} from './Footer/Footer'
import {Header} from './Header'
import {Main} from './Main/Main'

export const View = () => {
  const product = VentrataDataProvider.useProduct('optional')

  useGa4MountEffect(
    {
      event: 'view_ticket_selection',
      item_id: product.id,
      item_name: product.title,
      checkout_type: 'custom_checkout',
    },
    {enabled: !!product.id}
  )

  return (
    <div className="flex flex-col h-full">
      <Header title="Ticket selection" />
      <Main />
      <Footer />
    </div>
  )
}
